import { render, staticRenderFns } from "./u-swiper-pagination-fraction.vue?vue&type=template&id=c8a6fd4c&scoped=true&"
import script from "./u-swiper-pagination-fraction.vue?vue&type=script&lang=js&"
export * from "./u-swiper-pagination-fraction.vue?vue&type=script&lang=js&"
import style0 from "./u-swiper-pagination-fraction.vue?vue&type=style&index=0&id=c8a6fd4c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8a6fd4c",
  null
  
)

export default component.exports